

/**
 * @name StatePickerController
 * @description Controller for the state picker modal
 * @param {type} $uibModalInstance Description
 * @param {type} Collector Description
 * @param {type} Session Description
 * @param {type} Auth Description
 * @param {type} states Description
 * @param {type} logOutPossible Description
 * @param {type} _ Description
 */
function StatePickerController(
  $uibModalInstance,
  Collector,
  Session,
  Auth,
  states,
  logOutPossible,
  _
) {
  let vm = this;

  // Public Methods
  vm.cancel = cancel;
  vm.selectState = selectState;
  vm.session = Session;
  vm.states = states;

/**
  * Select a state
  * @param {object} state The selected state
  */
  function selectState(state) {
    $uibModalInstance.close(state);
  }

/**
  * Cancel from the state picker modal
  */
  function cancel() {
    $uibModalInstance.dismiss('Canceled');
    if (logOutPossible === true) {
      Auth.logout();
    }
  }
}

angular
  .module('inkfinder')
  .controller('StatePickerController', StatePickerController);



// WEBPACK FOOTER //
// ./components/auth/state-picker/state-picker.controller.js